import React from "react"
import styled from "styled-components"
import {withRouter} from "react-router-dom"
import PropTypes from "prop-types"

import {brand, greys} from "@irati/ui/src/global/colors"
import {HeaderLink} from "@irati/ui/src/HeaderComponents"

const Item = styled(HeaderLink)`
  ${(props) => props.location.pathname.includes(props.to) && `
    padding-top: 5px;
    border-radius: 0;
    border-bottom: 5px solid ${brand.shade};
  `}
  &:active,&:visited,&:focus {
    color: ${greys.mediumDark};
    text-decoration: none;
    background-color: transparent;
  }
`
const MenuItem = ({to, location, children}) => {
  return (
    <Item to={to} location={location}>
      {children}
    </Item>
  )
}
MenuItem.defaultProps = {
  to: null,
  location: null,
  children: null
}

MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  children: PropTypes.any
}

export default withRouter(MenuItem)
